// extracted by mini-css-extract-plugin
export var active = "_2x-2";
export var errorDot = "_2x-3";
export var sideNavContainer = "_2x-0";
export var sideNavLink = "_2x-1";